// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__WaI-2","title":"Info_title__3BiFZ","links":"Info_links__1qs_p","link":"Info_link__3rZ_Y","logo":"Info_logo__ICiwi"};